import * as Phaser from "phaser";

export class InteractiveRoomItem extends Phaser.GameObjects.Image {
  private onClickCallback: (() => void)[] = [];
  private scaleXTween?: Phaser.Tweens.Tween;
  private scaleYTween?: Phaser.Tweens.Tween;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    frame?: string,
    onClickCallback?: () => void,
  ) {
    // Создаем спрайт
    super(scene, x, y, texture, frame);

    // Инициализируем свойства
    if (onClickCallback) {
      this.onClickCallback.push(onClickCallback);
    }
    this.setInteractive({ useHandCursor: true });

    // Добавляем обработчики событий
    this.on("pointerdown", this.onClick.bind(this));
    this.on("pointerover", this.onHover.bind(this));
    this.on("pointerout", this.onOut.bind(this));

    const delay = Math.random() * 2000;

    this.scaleXTween = this.scene.tweens.add({
      targets: this,
      scaleX: 1.03,
      duration: 400,
      ease: "Power2",
      repeat: -1,
      delay,
      yoyo: true,
    });

    this.scaleYTween = this.scene.tweens.add({
      targets: this,
      scaleY: 1.03,
      duration: 400,
      ease: "Power2",
      delay: delay + 150,
      yoyo: true,
      repeat: -1,
    });
  }

  private onClick(): void {
    for (const callback of this.onClickCallback) {
      callback();
    }
  }

  private onHover(): void {
    // Паузим твины масштабирования
    if (this.scaleXTween) {
      this.scaleXTween.pause();
    }
    if (this.scaleYTween) {
      this.scaleYTween.pause();
    }

    // Анимация увеличения и вращения
    this.scene.tweens.add({
      targets: this,
      scaleX: 1.1,
      scaleY: 1.1,
      angle: Math.random() * 5 - 2.5,
      duration: 200,
      ease: "Power2",
    });
  }

  private onOut(): void {
    // Анимация возврата к исходному состоянию
    this.scene.tweens.add({
      targets: this,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      duration: 200,
      ease: "Power2",
      onComplete: () => {
        // Возобновляем твины масштабирования после завершения анимации
        if (this.scaleXTween) {
          this.scaleXTween.resume();
        }
        if (this.scaleYTween) {
          this.scaleYTween.resume();
        }
      },
    });
  }

  public setOnClickCallback(callback: () => void): void {
    this.onClickCallback.push(callback);
  }

  public pauseScaleTweens(): void {
    if (this.scaleXTween) {
      this.scaleXTween.pause();
    }
    if (this.scaleYTween) {
      this.scaleYTween.pause();
    }
  }

  public resumeScaleTweens(): void {
    if (this.scaleXTween) {
      this.scaleXTween.resume();
    }
    if (this.scaleYTween) {
      this.scaleYTween.resume();
    }
  }

  public override destroy(): void {
    super.destroy();
  }
}
